(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bymehru-dress"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLSelectElement) || !event.target.matches('.bm-product-form select[name="id"]')) return;
    const price = event.target.selectedOptions[0]?.dataset.price;
    const display = event.target.closest('.bm-dress-copy')?.querySelector('[data-dress-price]');
    if (price && display) display.textContent = price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bymehru-header"] && !Shopify.designMode) return;
  try {
    
  const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (previewTheme) {
    document.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.href);
      if (url.origin === window.location.origin && (url.pathname === '/' || url.pathname === '/cart' || url.pathname.startsWith('/products/') || url.searchParams.has('view'))) {
        url.searchParams.set('preview_theme_id', previewTheme);
        link.href = url.href;
      }
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.bm-mobile-nav nav a');
    if (link) link.closest('details').removeAttribute('open');
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.bm-mobile-nav[open]');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
